export const WORKBENCH_REQUIREMENT_TEMPLATE_TYPE = {
  LOAN: 1,
  INSURANCE: 2,
};
